import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
import { YFormat, yFormatters } from './palette';

// Number that counts up from zero on first view, then tweens to new values.
// Ported from splitfin-manager src/components/dash/count-up.tsx.
export const CountUp: React.FC<{ value: number; format?: YFormat | ((v: number) => string); duration?: number; className?: string }> = ({
  value,
  format = 'int',
  duration = 0.9,
  className,
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(0);
  const last = useRef(0);
  const fmt = typeof format === 'function' ? format : yFormatters[format];

  useEffect(() => {
    if (!inView || reduce) return;
    const controls = animate(last.current, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(v),
      onComplete: () => {
        last.current = value;
      },
    });
    return () => controls.stop();
  }, [value, inView, duration, reduce]);

  return (
    <span ref={ref} className={className}>
      {fmt(reduce ? value : display)}
    </span>
  );
};
